import formclasses from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import classes from "../../Company/AddNewCompany/AddNewCompany.module.css";
import editClasses from "../../Company/EditNewCompany/EditNewCompany.module.css";
import React, { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useFormik, useFormikContext } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";

import axios from "axios";
import { toast } from "react-toastify";
import ReactFileReader from "react-file-reader";
import authContext from "../../../../AuthContext/authContext";
import ManagersTable from "../../Company/ManagersTable/ManagersTable";
import { useNavigate } from "react-router-dom";
const base_url = process.env.REACT_APP_BASE_URL;
const EditNewBuilding = ({ initialData }) => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(
    new Date(initialData.subscriptionStartDate.slice(0, 10))  
  );
  const [endDate, setEndDate] = useState(
    new Date(initialData.subscriptionEndDate.slice(0, 10))
  );
  const [preview, setPreview] = useState(initialData.logo);
  const [loadingQR, setLoadingQR] = useState(false);
  const [loading, setLoading] = useState(false);
  const ctx = useContext(authContext);
  const token = ctx.token;
  console.log(initialData,"initialData");
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const nameRegExp = /^[A-Za-z ]+$/;
    const [managers, setManagers] = useState(
       initialData.managers && initialData.managers.length > 0
         ? initialData.managers.filter(manager => manager.user_type === "Building Manager").map((manager, index) => ({
           id: manager._id || `new-${index}`,
           name: manager.name || "",
           email: manager.email || "",
           phone: manager.phone || "",
           user_type: manager.user_type === "company" ? `Company_Manager` : manager.user_type ,
           password: "",
           _id: manager._id,
           deletable: manager.user_type === "company" && !manager.location_id ? false : true,
           location: manager.location || "",
           isEditing: false
         }))
         : []
     );
     console.log(managers,"managers");

     const sortedPpoData = [...(initialData.ppoData || [])].filter((item) => item.isActive);
     console.log(sortedPpoData, "sortedPpoData");
   
     // Get the latest PPO entry or use defaults
     const latestPpo = sortedPpoData.length > 0 ? {
       ppoNote: sortedPpoData[0].ppoNote || "",
       ppoPassCount: sortedPpoData[0].ppoPassCount || 0,
       availablePassCount: sortedPpoData[0].availablePassCount || 0,
       ppomodel: sortedPpoData[0].ppomodel || false,
       isActive: sortedPpoData[0].isActive || false,
       createdAt: sortedPpoData[0].createdAt || ""
     } : {
       ppoNote: "",
       ppoPassCount: 0,
       availablePassCount: 0,
       ppomodel: false,
       isActive: false,
       createdAt: ""
     };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_name: initialData.name,
      managers: managers,
      storage_duration: initialData.storageDuration,
      start_date: startDate,
      end_date: endDate,
      allowed_location: 500,
      location_switch: true,
      visitor_verification: initialData.visitorVerification,
      geoLocation_switch: initialData.geoLocation || false,
      valid_id: initialData.validId || false,
      accessory_check: initialData.accessoryCheck || false,
      prebooking_switch: initialData.prebookingSwitch || false,
      guard_check: initialData.guardCheck || false,
      boombarier_qr_check: initialData.boombarierQrCheck || false,
      card_check: initialData.cardCheck || false,
      delagate_check: initialData.delagateCheck || false,
      vendor_check: initialData.vendorCheck || false,
      endMeetingNotification: initialData.endMeetingNotification || false,
      employeeApprovalMailCheck: initialData.employeeApprovalMailCheck || false,
      Bgcolor: initialData.backgroundColor,
      footer_switch: initialData.footerStatus,
      footer_line_1: initialData.footerStatus ? initialData.footerTextOne : "",
      footer_line_2: initialData.footerStatus ? initialData.footerTextTwo : "",
      directory_switch: initialData.employeeDirectory,
      logo: initialData.logo,
      que1: initialData.covidQuestionOne || "",
      ans1: initialData.covidAnswerOne || "",
      que2: initialData.covidQuestionTwo || "",
      ans2: initialData.covidAnswerTwo || "",
      que3: initialData.covidQuestionThree || "",
      ans3: initialData.covidAnswerThree || "",
      que4: initialData.covidQuestionFour || "",
      ans4: initialData.covidAnswerFour || "",
      que5: initialData.covidQuestionFive || "",
      ans5: initialData.covidAnswerFive || "",
      standy: initialData.standy || "",
      ppoNote: latestPpo.ppoNote,
      ppoPassCount: latestPpo.ppoPassCount,
      availablePassCount: latestPpo.availablePassCount,
      ppo_enabled: latestPpo.ppomodel,
      isActive: latestPpo.isActive,
      createdAt: latestPpo.createdAt,
      ppo_expiry_date: latestPpo.expiryDate
    },
    validationSchema: Yup.object({
      company_name: Yup.string().required("Please enter your name"),
     managers: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .matches(nameRegExp, "Please enter valid name")
            .required("Please enter company manager name"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Please enter company manager email address"),
          phone: Yup.string()
            .matches(phoneRegExp, "Phone number is not valid")
            .length(10, "Phone number should be of 10 digits")
            .required("Please enter company manager phone no."),
        })
      ),
      storage_duration: Yup.string().required(
        "Please enter data storage duration"
      ),
      start_date: Yup.string().required("Please enter start date"),
      end_date: Yup.string().required("Please enter end date"),
      logo: Yup.mixed(),
      que1: Yup.string(),
      ans1: Yup.string(),
      que2: Yup.string(),
      ans2: Yup.string(),
      que3: Yup.string(),
      ans3: Yup.string(),
      que4: Yup.string(),
      ans4: Yup.string(),
      que5: Yup.string(),
      ans5: Yup.string(),
      geoLocation_switch: Yup.boolean(),
      valid_id: Yup.boolean(),
      accessory_check: Yup.boolean(),
      prebooking_switch: Yup.boolean(),
      guard_check: Yup.boolean(),
      boombarier_qr_check: Yup.boolean(),
      card_check: Yup.boolean(),
      delagate_check: Yup.boolean(),
      vendor_check: Yup.boolean(),
      endMeetingNotification: Yup.boolean(),
      employeeApprovalMailCheck: Yup.boolean(),
      location_switch: Yup.boolean()
    }),
    onSubmit: (values) => {
      // console.log(values, "values");
      setLoading(true);
      const formData = new FormData();
      formData.append("id", initialData._id);
      formData.append("name", values.company_name);
      formData.append("type", "Building");
      formData.append("managers", JSON.stringify(managers));
      formData.append("storageDuration", values.storage_duration);
      if (managers.length > 0) {
        formData.append("managerName", managers[0].name);
        formData.append("managerEmail", managers[0].email);
        formData.append("managerPhone", managers[0].phone);
        formData.append("password", values.managers[0].password); // Using phone as default password
      }
      formData.append("userType", "Building Manager");
      formData.append(
        "subscriptionStartDate",  
        values.start_date.toISOString().slice(0, 10)
      );
      formData.append(
        "subscriptionEndDate",
        values.end_date.toISOString().slice(0, 10)
      );
      formData.append("location", values.location_switch);
      formData.append("noOfLocation", values.allowed_location);
      formData.append("visitorVerification", values.visitor_verification);
      formData.append("geoLocation", values.geoLocation_switch);
      formData.append("validId", values.valid_id);
      formData.append("accessoryCheck", values.accessory_check);
      formData.append("prebookingSwitch", values.prebooking_switch);
      formData.append("guardCheck", values.guard_check);
      formData.append("boombarierQrCheck", values.boombarier_qr_check);
      // formData.append("ppoEnabled", values.ppo_enabled);
      formData.append("cardCheck", values.card_check);
      formData.append("delagateCheck", values.delagate_check);
      formData.append("vendorCheck", values.vendor_check);
      formData.append("endMeetingNotification", values.endMeetingNotification);
      formData.append(
        "employeeApprovalMailCheck",
        values.employeeApprovalMailCheck
      );
      formData.append("backgroundColor", values.Bgcolor);
      if (values.logo) {
        formData.append("logoFile", values.logo);
      }
      formData.append("footerStatus", values.footer_switch);
      // formData.append(
      //   "footerTextOne",
      //   values.footer_switch ? values.footer_line_1 : ""
      // );
      // formData.append(
      //   "footerTextTwo",
      //   values.footer_switch ? values.footer_line_2 : ""
      // );
      if (values.footer_switch) {
        formData.append("footerTextOne", values.footer_line_1);
        formData.append("footerTextTwo", values.footer_line_2);
      }
      formData.append("employeeDirectory", values.directory_switch);

      if (values.que1 !== "") {
        formData.append("covidQuestionOne", values.que1);
        formData.append("covidAnswerOne", values.ans1);
      }
      if (values.que2 !== "") {
        formData.append("covidQuestionTwo", values.que2);
        formData.append("covidAnswerTwo", values.ans2);
      }
      if (values.que3 !== "") {
        formData.append("covidQuestionThree", values.que3);
        formData.append("covidAnswerThree", values.ans3);
      }
      if (values.que4 !== "") {
        formData.append("covidQuestionFour", values.que4);
        formData.append("covidAnswerFour", values.ans4);
      }
      if (values.que5 !== "") {
        formData.append("covidQuestionFive", values.que5);
        formData.append("covidAnswerFive", values.ans5);
      }

      axios
        .put(`${base_url}/company/update`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then((res) => {
          toast.success("Building Updated Successfully!!");
          setLoading(false);
        })
        .catch((err) => {
          // console.log(err);
          toast.error(
            err.response.data.error.message || "Failed to update Building"
          );
          setLoading(false);
        });
    }
  });
  const addManager = () => {
    setManagers([...managers, { name: "", email: "", phone: "", password: "" }]);
  };

  const removeManager = (index) => {
    const newManagers = [...managers];
    newManagers.splice(index, 1);
    setManagers(newManagers);
  };

  const handleManagerChange = (index, field, value) => {
    const newManagers = [...managers];
    newManagers[index] = { ...newManagers[index], [field]: value };
    setManagers(newManagers);
  };

  
  const handleFile = (file) => {
    setPreview(file.base64);
    formik.setFieldValue("logo", file.fileList[0]);
  };

  function downloadImage(dataURL) {
    var link = document.createElement("a");
    link.download = "building-qr.png";
    link.href = dataURL;
    link.click();
  }

  const donwloadQrCode = (url) => {
    downloadImage(url);
  };

  const generateQrCode = () => {
    setLoadingQR(true);
    axios
      .post(
        `${base_url}/company/generate-qr-code`,
        {
          companyId: initialData._id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then((res) => {
        toast.dismiss();
        toast.success("Qr code generated Successfully!!");
        setLoadingQR(false);
        setTimeout(() => {
          formik.setFieldValue("standy", res.data.standyUrl);
        }, 0);
      })
      .catch((err) => {
        // console.log(err);
        toast.dismiss();
        toast.error(
          err.response.data.error.message || "Failed to generate Qr code"
        );
        setLoadingQR(false);
      });
  };

  return (
    <>
      <div className={`${formclasses.mainCont} ${classes.Container}`}>
        <h3>Edit New Building</h3>

        <form className={formclasses.FormDiv} onSubmit={formik.handleSubmit}>
          <div className={editClasses.editDiv}>
            <div style={{ width: "70%" }}>
              <div className={`${formclasses.formGrp}`}>
                <label for="company_name">Building Name:</label>
                <div>
                  <input
                    type="text"
                    id="company_name"
                    name="company_name"
                    {...formik.getFieldProps("company_name")}
                  />
                  <span className={formclasses.profileerrMsg}>
                    {formik.touched.company_name &&
                    formik.errors.company_name ? (
                      <div>{formik.errors.company_name}</div>
                    ) : null}
                  </span>
                </div>
              </div>
              {/* <div className={formclasses.formGrp}>
                <label for="manager_name">Building Manager Name: </label>
                <div>
                  <input
                    type="text"
                    id="manager_name"
                    name="manager_name"
                    {...formik.getFieldProps("manager_name")}
                  />
                  <span className={formclasses.profileerrMsg}>
                    {formik.touched.manager_name &&
                    formik.errors.manager_name ? (
                      <div>{formik.errors.manager_name}</div>
                    ) : null}
                  </span>
                </div>
              </div>
              <div className={formclasses.formGrp}>
                <label for="manager_email">Building Manager Email: </label>
                <div>
                  <input
                    type="text"
                    id="manager_email"
                    name="manager_email"
                    {...formik.getFieldProps("manager_email")}
                  />
                  <span className={formclasses.profileerrMsg}>
                    {formik.touched.manager_email &&
                    formik.errors.manager_email ? (
                      <div>{formik.errors.manager_email}</div>
                    ) : null}
                  </span>
                </div>
              </div>
              <div className={formclasses.formGrp}>
                <label for="manager_phone">Building Manager Phone:</label>
                <div>
                  <input
                    type="text"
                    id="manager_phone"
                    name="manager_phone"
                    {...formik.getFieldProps("manager_phone")}
                  />
                  <span className={formclasses.profileerrMsg}>
                    {formik.touched.manager_phone &&
                    formik.errors.manager_phone ? (
                      <div>{formik.errors.manager_phone}</div>
                    ) : null}
                  </span>
                </div>
              </div> */}
                 <ManagersTable
                  managers={managers}
                  setManagers={setManagers}
                  formik={formik}
                  id={initialData._id}
                  handleManagerChange={handleManagerChange}
                  token={token}
                  base_url={base_url}
                />


              <div className={formclasses.formGrp}>
                <label for="storage_duration">Data Duration Storage:</label>
                <div>
                  <select
                    id="storage_duration"
                    name="storage_duration"
                    className={classes.dropDown}
                    {...formik.getFieldProps("storage_duration")}
                    placeholder="Select"
                  >
                    <option value="" disabled selected>
                      Select your option
                    </option>
                    <option value="1 Month">1 Month</option>
                    <option value="3 Month">3 Month</option>
                    <option value="6 Month">6 Month</option>
                    <option value="6 Month">9 Month</option>
                    <option value="12 Month">12 Month</option>
                  </select>
                  <span className={formclasses.profileerrMsg}>
                    {formik.touched.storage_duration &&
                    formik.errors.storage_duration ? (
                      <div>{formik.errors.storage_duration}</div>
                    ) : null}
                  </span>
                </div>

                {/* <input type="text" id="lname" name="lname" /> */}
              </div>

              <div
                className={`${formclasses.formGrp}`}
                style={{ display: "flex", margin: "0.8rem 0 0.8rem 0" }}
              >
                <label for="subscription">Subscription:</label>
                <span>
                  <span className={classes.dateDiv}>
                    <DatePicker
                      id="start_date"
                      name="start_date"
                      showYearDropdown
                      minDate={new Date()}
                      placeholderText="Start Date"
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        formik.setFieldValue("start_date", date);
                      }}
                      onBlur={formik.handleBlur}
                      value={startDate}
                      className={classes.customDate}
                    />

                    <div
                      style={{
                        width: "10%",
                        height: "0px",
                        backgroundColor: "black",
                        border: "1px solid black",
                        margin: "0 12px 0 0px"
                      }}
                    ></div>

                    <DatePicker
                      id="end_date"
                      name="end_date"
                      showYearDropdown
                      placeholderText="End Date"
                      selected={endDate}
                      minDate={new Date(formik.values.start_date + 1)}
                      onChange={(date) => {
                        setEndDate(date);
                        formik.setFieldValue("end_date", date);
                      }}
                      onBlur={formik.handleBlur}
                      value={startDate}
                      className={classes.customDate}
                    />
                  </span>
                  <span
                    className={formclasses.profileerrMsg}
                    style={{ marginLeft: "1.5rem", color: "rgb(223, 58, 58)" }}
                  >
                    {(formik.touched.start_date && formik.errors.start_date) ||
                    (formik.touched.end_date && formik.errors.end_date) ? (
                      <div>
                        {formik.errors.start_date || formik.errors.end_date}
                      </div>
                    ) : null}
                  </span>
                </span>
              </div>

              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label
                    className="form-check-label"
                    for="visitor_verification"
                  >
                    Visitor Verification
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="visitor_verification"
                    name="visitor_verification"
                    defaultChecked={formik.values.visitor_verification}
                    {...formik.getFieldProps("visitor_verification")}
                  />
                </div>
              </div>
              <div className={classes.colorDiv}>
                <div className={classes.pickerCont}>
                  <label for="Bgcolor">Background Color</label>
                  <div className={classes.picker}>
                    <input
                      type="color"
                      id="Bgcolor"
                      name="Bgcolor"
                      // value="#ff0000"
                      // defaultValue="#ffffff"
                      {...formik.getFieldProps("Bgcolor")}
                    />
                    <img
                      src={require("../../../../assets/img/admin-images/downIcon.png")}
                    />
                  </div>
                </div>

                {/* <ReactFileReader
                  name="logo"
                  fileTypes={[".png", ".jpg", ".jpeg"]}
                  handleFiles={handleFile}
                  handleBlur={formik.handleBlur}
                  base64={true}
                > */}
                <div className={classes.logoDiv}>
                  <label for="logo">Logo</label>

                  <ReactFileReader
                    name="logo"
                    fileTypes={[".png", ".jpg", ".jpeg"]}
                    handleFiles={handleFile}
                    handleBlur={formik.handleBlur}
                    base64={true}
                  >
                    <div className={`${classes.uploadBtnWrapper}`}>
                      <button type="button" className={`${classes.btn}`}>
                        <img
                          src={require("../../../../assets/img/admin-images/upload.png")}
                        />
                        <div>Select</div>
                      </button>
                      {/* <input type="file" name="myfile" /> */}
                    </div>
                  </ReactFileReader>
                  <div className={classes.previewLogo}>
                    {preview && <img src={preview} />}
                  </div>
                  <div style={{ display: "block", color: "rgb(223, 58, 58)" }}>
                    {formik.touched.logo && formik.errors.logo ? (
                      <div>{formik.errors.logo}</div>
                    ) : null}
                  </div>
                </div>
                {/* </ReactFileReader> */}
                {/* <div className={classes.previewLogo}>
                  {preview && <img src={preview} />}
                </div> */}
              </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="footer_switch">
                    Footer
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="footer_switch"
                    name="footer_switch"
                    defaultChecked={formik.values.footer_switch}
                    {...formik.getFieldProps("footer_switch")}
                  />
                </div>
              </div>
              {formik.values.footer_switch && (
                <>
                  <input
                    className={classes.footerInpDiv}
                    placeholder="Powered by Fedicoms Pvt Ltd."
                    id="footer_line_1"
                    name="footer_line_1"
                    {...formik.getFieldProps("footer_line_1")}
                  />{" "}
                  <br />
                  <input
                    className={classes.footerInpDiv}
                    placeholder="info@fedicoms.com"
                    id="footer_line_2"
                    name="footer_line_2"
                    {...formik.getFieldProps("footer_line_2")}
                  />
                </>
              )}
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="directory_switch">
                    Employee Directory
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="directory_switch"
                    name="directory_switch"
                    defaultChecked={formik.values.directory_switch}
                    {...formik.getFieldProps("directory_switch")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="geoLocation_switch">
                    Geo Location
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="geoLocation_switch"
                    name="geoLocation_switch"
                    defaultChecked={formik.values.geoLocation_switch}
                    {...formik.getFieldProps("geoLocation_switch")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="valid_id">
                    Valid Id
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="valid_id"
                    name="valid_id"
                    defaultChecked={formik.values.valid_id}
                    {...formik.getFieldProps("valid_id")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
            <div className="form-check form-switch">
              <label className="form-check-label" for="prebooking_switch">
                Enable Appointment
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                id="prebooking_switch"
                name="prebooking_switch"
                defaultChecked={formik.values.prebooking_switch}
                {...formik.getFieldProps("prebooking_switch")}
              />
            </div>
          </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="accessory_check">
                    Accessory
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="accessory_check"
                    name="accessory_check"
                    defaultChecked={formik.values.accessory_check}
                    {...formik.getFieldProps("accessory_check")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="card_check">
                    Card No
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="card_check"
                    name="card_check"
                    defaultChecked={formik.values.card_check}
                    {...formik.getFieldProps("card_check")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="delagate_check">
                    Delagate Pass
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="delagate_check"
                    name="delagate_check"
                    defaultChecked={formik.values.delagate_check}
                    {...formik.getFieldProps("delagate_check")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label className="form-check-label" for="vendor_check">
                    Vendor Pass
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="vendor_check"
                    name="vendor_check"
                    defaultChecked={formik.values.vendor_check}
                    {...formik.getFieldProps("vendor_check")}
                  />
                </div>
              </div>
              <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="guard_check">
                      Guard
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="guard_check"
                      name="guard_check"
                      defaultChecked={formik.values.guard_check}
                      {...formik.getFieldProps("guard_check")}
                    />
                  </div>
                </div>
                <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" for="boombarier_qr_check">
                    Boom Barrier QR Code
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="boombarier_qr_check"
                      name="boombarier_qr_check"
                      defaultChecked={formik.values.boombarier_qr_check}
                      {...formik.getFieldProps("boombarier_qr_check")}
                    />
                  </div>
                </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label
                    className="form-check-label"
                    for="employeeApprovalMailCheck"
                  >
                    Employee Approval Mail
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="employeeApprovalMailCheck"
                    name="employeeApprovalMailCheck"
                    defaultChecked={formik.values.employeeApprovalMailCheck}
                    {...formik.getFieldProps("employeeApprovalMailCheck")}
                  />
                </div>
              </div>

              <div className={classes.toggleSwitch}>
                  <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="ppo_enabled">
                      Enable PPU
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="ppo_enabled"
                      name="ppo_enabled"
                      checked={formik.values.ppo_enabled}
                      onChange={async (e) => {
                        const newValue = e.target.checked;
                        formik.setFieldValue('ppo_enabled', newValue);

                        if (!newValue) {
                          // Call API to disable PPO
                          try {
                            await axios({
                              method: 'PUT',
                              url: `${base_url}/company/unsubscribe-ppo/${initialData._id}`,
                              headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json'
                              }
                            });
                            toast.success("PPU disabled successfully");
                          } catch (error) {
                            console.error('Failed to disable PPO:', error);
                            // Revert the toggle if API call fails
                            formik.setFieldValue('ppo_enabled', true);
                            toast.error("Failed to disable PPU");
                          }
                        } else {
                          // Navigate to add PPO configuration page
                          navigate(`/company/${initialData._id}/add-ppo-configuration`, {
                            state: {
                              companyName: initialData.name,
                            },
                          });
                        }
                      }}
                    />
                    {formik.values.ppo_enabled && (

                      <button
                        type="button"
                        className="btn btn-sm btn-link p-0 ms-2"
                        onClick={() => navigate(`/company/${initialData._id}/ppo-configuration`, {
                          state: {
                            companyName: initialData.name,
                          },
                        })}
                      >
                        Configure PPU
                      </button>
                    )}
                  </div>
                </div>
              <div className={classes.toggleSwitch}>
                <div className="form-check form-switch">
                  <label
                    className="form-check-label"
                    for="endMeetingNotification"
                  >
                    End Meeting Notification
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    // id="flexSwitchCheckChecked"
                    id="endMeetingNotification"
                    name="endMeetingNotification"
                    defaultChecked={formik.values.endMeetingNotification}
                    {...formik.getFieldProps("endMeetingNotification")}
                  />
                </div>
              </div>
            </div>

            {/* <div className={editClasses.rightContainer}>
              <div className={editClasses.QrContainer}>
                <div className={editClasses.codeDiv}>
                  <img src={require("../../../../assets/img/admin-images/qrcode.png")} />
                </div>
                <img
                  className={editClasses.editLogo}
                  src={require("../../../../assets/img/admin-images/edit.png")}
                />
                <img
                  className={editClasses.downloadIcon}
                  src={require("../../../../assets/img/admin-images/download.png")}
                />
              </div>
            </div> */}
            <div className={editClasses.rightContainer}>
              <div className={editClasses.QrContainer}>
                {!formik.values.standy ? (
                  <button
                    className="btn btn-primary mb-2"
                    type="button"
                    disabled={loadingQR}
                    onClick={() => {
                      generateQrCode();
                    }}
                  >
                    {loadingQR && (
                      <div
                        className="spinner-border spinner-border-sm mr-1"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    Generate QR Code
                  </button>
                ) : (
                  <>
                    {loadingQR ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm mr-1 loadQr"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </>
                    ) : (
                      <div className={editClasses.codeDiv}>
                        <div>
                          <img
                            style={{ height: "100%", width: "100%" }}
                            src={formik.values.standy}
                          />
                          <img
                            className={editClasses.editLogo}
                            src={require("../../../../assets/img/admin-images/edit.png")}
                            onClick={() => generateQrCode()}
                          />
                          <img
                            className={editClasses.downloadIcon}
                            onClick={() => {
                              donwloadQrCode(formik.values.standy);
                            }}
                            src={require("../../../../assets/img/admin-images/download.png")}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <hr className={classes.hr1} />
          <div>
            <h3>Edit Covid Questions</h3>
            <div>
              <input
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Q1. Add Title"
                id="que1"
                name="que1"
                {...formik.getFieldProps("que1")}
              />
              <textarea
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Answer"
                id="ans1"
                name="ans1"
                {...formik.getFieldProps("ans1")}
              />
              <span className={formclasses.profileerrMsg}>
                {formik.touched.ans1 && formik.errors.ans1 ? (
                  <div>{formik.errors.ans1}</div>
                ) : null}
              </span>
            </div>
            <hr className={classes.hr1} style={{ width: "80%" }} />

            <div>
              <input
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Q2. Add Title"
                id="que2"
                name="que2"
                {...formik.getFieldProps("que2")}
              />
              <textarea
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Answer"
                id="ans2"
                name="ans2"
                {...formik.getFieldProps("ans2")}
              />
            </div>
            <hr className={classes.hr1} style={{ width: "80%" }} />

            <div>
              <input
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Q3. Add Title"
                id="que3"
                name="que3"
                {...formik.getFieldProps("que3")}
              />
              <textarea
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Answer"
                id="ans3"
                name="ans3"
                {...formik.getFieldProps("ans3")}
              />
            </div>
            <hr className={classes.hr1} style={{ width: "80%" }} />

            <div>
              <input
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Q4. Add Title"
                id="que4"
                name="que4"
                {...formik.getFieldProps("que4")}
              />
              <textarea
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Answer"
                id="ans4"
                name="ans4"
                {...formik.getFieldProps("ans4")}
              />
            </div>
            <hr className={classes.hr1} style={{ width: "80%" }} />

            <div>
              <input
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Q5. Add Title"
                id="que5"
                name="que5"
                {...formik.getFieldProps("que5")}
              />
              <textarea
                className={`${classes.footerInpDiv} ${classes.covidQue}`}
                placeholder="Answer"
                id="ans5"
                name="ans5"
                {...formik.getFieldProps("ans5")}
              />
            </div>
          </div>
          <div className={formclasses.formBtn}>
            {/* <button className={formclasses.cancleBtn}>Cancle</button> */}
            <button type="submit" className={formclasses.createBtn}>
              {loading && (
                <div
                  className="spinner-border spinner-border-sm mr-1"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              Update
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditNewBuilding;
